import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ApiService} from '../../../services/api.service';
import {ProfileListDetailComponent} from '../profile-list-detail/profile-list-detail.component';
import * as _ from 'lodash';
import {TranslateService} from '@ngx-translate/core';
import {Subscription} from "rxjs";
@Component({
  selector: 'profile-list',
  templateUrl: './profile-list.component.html',
  styleUrls: ['./profile-list.component.scss'],
})
export class ProfileListComponent implements OnInit, OnDestroy {
  itemsPerPage = 40;
  searchUsername: any = '';
  searchGroup: any;
  groups: any = [];
  totalItems: number;
  currentPage = 1;
  loading = false;
  list: any = [];
  subs: Subscription;

  @ViewChild('detailModal') detailModal: ProfileListDetailComponent;
  @ViewChild(ProfileListDetailComponent) profileListDetail: ProfileListDetailComponent;

  constructor(private apiService: ApiService,
              private translate: TranslateService) {
  }

  ngOnInit() {
    this.subs = this.translate.onLangChange.subscribe((res: string) => {
      this.loadGroups();
    });
    this.pageChanged();
    this.loadGroups();
  }

  reload() {
    this.pageChanged();
  }

  pageChanged() {
    this.loadData();
  }

  optionChanged() {
    this.search();
  }

  openModal(data, index) {
    this.detailModal.open(this, data);
  }

  search() {
    this.currentPage = 1;
    this.loadData();
  }

  loadData() {
    const data = {
      page: this.currentPage,
      items_per_page: this.itemsPerPage,
      username: this.searchUsername
    };

    if (this.searchGroup != null) {
      data['group'] = this.searchGroup;
    }

    this.loading = true;
    this.apiService.getUsers(data).subscribe(
      (res: any) => {
        this.list = res.results;
        this.totalItems = res.count;
        this.loading = false;
      },
      error => {
        this.loading = false;
      }
    );
  }

  clearSearch() {
    this.searchGroup = null;
    this.searchUsername = '';
    this.search();
  }

  disableUser(user: any) {
    this.sniff('DISABLE_USER', user.username);
    this.apiService.deleteUser(user).subscribe(
      (obj) => {
        user.is_active = false
      },
      error => {
        console.log(error)
      }
    );
  }

  enableUser(user: any) {
    this.sniff('ENABLE_USER', user.username);
    user.is_active = true;
    this.apiService.updateUser(user).subscribe(
      (obj) => {
      },
      (error) => {
        user.is_active = false;
      }
    );
  }


  toggleUserStatus(user: any) {
    if (user.is_active) {
      this.disableUser(user);
    } else {
      this.enableUser(user);
    }
  }

  loadGroups() {
    this.groups = [{
      'label': this.translate.instant('COMMON.ALL'),
      'value': null
    }];
    const params = {
      source: 'profile'
    };
    this.apiService.getRoles(params).subscribe(
      (groups) => {
        _.forEach(groups, (group) => {
          this.groups.push({
            'label': group['name'],
            'value': group['id']
          });
        });
        this.groups = _.uniqBy(this.groups, 'label');
      },
      error => {
      }
    );
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  sniff(action, target) {
    const data = {
      action: action,
      address: 'MANAGE_USERS',
      target: target
    };
    this.apiService.sniff(data).subscribe(
      (res: any) => {
      },
    );
  }

}




// WEBPACK FOOTER //
// /opt/app/src/app/features/profile/profile-list/profile-list.component.ts